import React, { useState } from 'react';
import { useCompany } from './CompanyContext';
import { 
  Button, 
  Popover, 
  List, 
  ListItem, 
  Checkbox, 
  ListItemText, 
  Typography,
  Divider,
  Box
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import BusinessIcon from '@mui/icons-material/Business';

function GlobalCompanySelector() {
  const { companies, selectedCompanyIds, setSelectedCompanyIds } = useCompany();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (companyId) => {
    const currentIndex = selectedCompanyIds.indexOf(companyId);
    const newSelectedCompanyIds = [...selectedCompanyIds];

    if (currentIndex === -1) {
      newSelectedCompanyIds.push(companyId);
    } else {
      newSelectedCompanyIds.splice(currentIndex, 1);
    }

    setSelectedCompanyIds(newSelectedCompanyIds);
  };

  const handleSelectAll = () => {
    if (selectedCompanyIds.length === companies.length) {
      setSelectedCompanyIds([]); // Deselect all
    } else {
      setSelectedCompanyIds(companies.map(c => c.id)); // Select all
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'global-company-popover' : undefined;

  const isAllSelected = companies.length > 0 && selectedCompanyIds.length === companies.length;
  
  const getButtonText = () => {
    if (selectedCompanyIds.length === 0) return "Ninguna Empresa";
    if (isAllSelected) return "Todas las Empresas";
    if (selectedCompanyIds.length === 1) {
        const company = companies.find(c => c.id === selectedCompanyIds[0]);
        return company ? company.nombre : "1 Empresa";
    }
    return `${selectedCompanyIds.length} Empresas Seleccionadas`;
  }

  return (
    <>
      <Button
        aria-describedby={id}
        variant="contained"
        color="inherit"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        sx={{ 
            color: 'primary.main', 
            bgcolor: 'white', 
            '&:hover': { bgcolor: 'grey.200' },
            textTransform: 'none',
            fontWeight: 'bold'
        }}
      >
        <BusinessIcon sx={{ mr: 1, color: 'grey.600' }} />
        {getButtonText()}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
            sx: { width: 320, mt: 1 }
        }}
      >
        <Box sx={{ p: 2 }}>
            <Typography variant="subtitle1">Filtrar por Empresa</Typography>
        </Box>
        <Divider />
        <List dense>
          <ListItem button onClick={handleSelectAll}>
            <Checkbox
              edge="start"
              checked={isAllSelected}
              tabIndex={-1}
              disableRipple
            />
            <ListItemText primary="Todas las empresas" />
          </ListItem>
          <Divider />
          {companies.map((company) => (
            <ListItem key={company.id} button onClick={() => handleToggle(company.id)}>
              <Checkbox
                edge="start"
                checked={selectedCompanyIds.indexOf(company.id) !== -1}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText primary={company.nombre} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
}

export default GlobalCompanySelector;